import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import { stepStyles } from "../formStyles";

export const OwnLotOfLand = ({ formData, setForm, navigation, step }) => {
  const [error, setError] = useState(false);
  const [isVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const ownLotOfLand = [
    { id: "Owns Lot of Land", title: "Yes" },
    { id: "Does not own lot of land", title: "Not yet, still looking" },
  ];
  const checkForNextStep = () => {
    if (formData.ownLotOfLand === "") {
      setError(true);
      console.log("error");
    }
    if (formData.ownLotOfLand !== "") {
      navigation.next();
      console.log("next");
    }
  };

  return (
    <div className={stepStyles.page}>
      <ProgressBar width={"20%"} />
      <div className={stepStyles.content}>
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className={stepStyles.panel}>
              <h1 className={stepStyles.title}>Do you already own the lot or land to build on?</h1>
              <div className="w-full">
                <label className="text-base font-medium text-gray-900"></label>
                <fieldset className="">
                  <legend className="sr-only">Are you already working with a builder/contractor?</legend>
                  <div className={stepStyles.optionGroup}>
                    {ownLotOfLand.map((ownLotOfLand) => (
                      <label key={ownLotOfLand.id} className={stepStyles.optionRow}>
                        <input
                          onChange={setForm}
                          value={ownLotOfLand.id}
                          id={ownLotOfLand.id}
                          name="ownLotOfLand"
                          type="radio"
                          className={stepStyles.radio}
                        />
                        <span className={stepStyles.label}>{ownLotOfLand.title}</span>
                      </label>
                    ))}
                  </div>
                  {error ? <p className={stepStyles.error}>please fill out an answer</p> : null}
                </fieldset>
              </div>
            </animated.div>
          ) : null,
        )}
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => checkForNextStep()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
